/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Student {
  baseApi = ENV.BASE_API;

  async getStudentsByGradeAndAcademicCycle(
    accessToken,
    gradeId,
    academicCycleId
  ) {
    try {
      const response = await this.getStudents(
        accessToken,
        gradeId,
        academicCycleId,
        {},
        1,
        1000
      );
      return response.data || response;
    } catch (error) {
      throw error;
    }
  }

  async getStudents(
    accessToken,
    gradeId,
    academicCycleId,
    filters,
    page = 1,
    pageSize = 10
  ) {
    try {
      // Construir la cadena de consulta a partir de los filtros
      const queryParams = new URLSearchParams({
        page,
        pageSize,
        ...filters,
      }).toString();

      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/${gradeId}/${academicCycleId}?${queryParams}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getStudentsAndAcademicAdvance(
    accessToken,
    gradeId,
    academicCycleId,
    filters,
    page = 1,
    pageSize = 10
  ) {
    try {
      // Construir la cadena de consulta a partir de los filtros
      const queryParams = new URLSearchParams({
        page,
        pageSize,
        ...filters,
      }).toString();

      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/${gradeId}/${academicCycleId}/academicManagement?${queryParams}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAcademicAdvanceByStudent(accessToken, userId, academicCycleId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/grades/${academicCycleId}/${userId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createStudent(accessToken, data) {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createReentryStudent(accessToken, data) {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/reentry`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateStudentStatus(accessToken, idStudent, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/status/${idStudent}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteStudent(accessToken, studentId, academicCycleId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/delete/${studentId}?academicCycleId=${academicCycleId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAcademicCyclesByUser(userId, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ACADEMIC_CYCLE_BY_USER}/${userId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getGradesByUserAndAcademicCycle(userId, academicCycleId, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/grades/${userId}?academicCycleId=${academicCycleId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAcademicHistoryByStudent(
    studentId,
    syllabuSubjectGradeId,
    accessToken
  ) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/${studentId}/academicHistory?syllabuSubjectGradeId=${syllabuSubjectGradeId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEvaluationResults(sessionId, studentId, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/${studentId}/evaluation?sessionId=${sessionId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateRecoveryGrade(accessToken, courseId, recoveryGrade) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/${courseId}/recovery`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          recoveryGrade: recoveryGrade,
          recoveryStatus: 2,
        }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async downloadBulkTemplate(accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/bulk-import/template`;
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!response.ok) throw await response.json();
      return await response.blob();
    } catch (error) {
      throw error;
    }
  }

  async bulkImportStudents(accessToken, academicCycleId, gradeId, file) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/bulk-import/${academicCycleId}/${gradeId}`;
      const response = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${accessToken}` },
        body: formData,
      });
      const result = await response.json();
      if (!response.ok) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateCourseGrade(accessToken, courseId, gradeData) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.STUDENT}/course/${courseId}/grade`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(gradeData),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
